// src/features/manual/api.ts
//
// The manual's reads, through the app's authenticated client (token, impersonation header). Kept
// behind one object so the module-level caches of the hooks and the tests have a single seam. The
// client is loaded on first use, so screens that only import the header button do not pull it in.

import type { ManualChapter, ManualIndex, ManualLang, ManualSearchResponse } from './types';

/** The API rewrites `img:<name>` to `/api/v1/ui/manual/images/<name>-<lang>`; the id is the last segment. */
export const imageIdFromSrc = (src: string): string => src.split('?')[0].split('/').pop() ?? src;

const client = () => import('@/providers/dataProvider').then((m) => m.default);

export const manualApi = {
  index: async (lang: ManualLang): Promise<ManualIndex> => (await client()).getManualIndex(lang),
  chapter: async (id: string, lang: ManualLang): Promise<ManualChapter> =>
    (await client()).getManualChapter(id, lang),
  search: async (query: string, lang: ManualLang): Promise<ManualSearchResponse> =>
    (await client()).searchManual(query, lang),
  image: async (src: string): Promise<Blob> => (await client()).getManualImage(imageIdFromSrc(src)),
};
